import * as React from 'react';

import Box from '../box';
import Typography from '../typography';
import Icon from '../icon';
import Button from '../button';
import { Root } from './styled';


type FilterLayoutProps = {
	clearLabel?: string;
	onClear: () => void;
}

const FiltersBlock: React.SFC<FilterLayoutProps> = ({ children, clearLabel, onClear }) => {
	return (
		<Root>
			<Box display='flex' alignItems='center' marginBottom='30px'>
				<Box display='flex' alignItems='center' marginRight='8px'>
					<Icon type='filter-list' color='muted' />
				</Box>
				<Typography.Text
					textTransform='uppercase'
					fontSize={13}
					fontWeight={700}>
						Фильтры
				</Typography.Text>
			</Box>
			<Box marginBottom='10px'>{children}</Box>
			<Button
				color='default'
				fullWidth
				onClick={onClear}>
				{clearLabel}
			</Button>
		</Root>
	);
}

FiltersBlock.displayName = 'FiltersBlock';
FiltersBlock.defaultProps = {
	clearLabel: 'Сбросить фильтр'
};

export default FiltersBlock;
